import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-equipment',
  templateUrl: './faq-equipment.component.html',
  styleUrls: ['./faq-equipment.component.css']
})
export class FaqEquipmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
